import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  height: 100vh;
}

.animate-float-1 {
  animation: float-1 20s ease-in-out infinite;
}

.animate-float-2 {
  animation: float-2 25s ease-in-out infinite;
}

.animate-float-3 {
  animation: float-3 18s ease-in-out infinite;
}

.animate-float-4 {
  animation: float-4 22s ease-in-out infinite;
}

.animate-float-5 {
  animation: float-5 28s ease-in-out infinite;
}

@keyframes float-1 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(40px, 60px) scale(1.05);
  }
  50% {
    transform: translate(20px, 30px) scale(0.95);
  }
  75% {
    transform: translate(60px, 10px) scale(1.02);
  }
}
@keyframes float-2 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(-30px, -40px) scale(1.08);
  }
  50% {
    transform: translate(-60px, -20px) scale(0.92);
  }
  75% {
    transform: translate(-20px, -50px) scale(1.04);
  }
}
@keyframes float-3 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(50px, -30px) scale(1.06);
  }
  66% {
    transform: translate(20px, -60px) scale(0.96);
  }
}
@keyframes float-4 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-40px, 30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 50px) scale(0.9);
  }
}
@keyframes float-5 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, -20px) scale(1.04);
  }
  50% {
    transform: translate(60px, 20px) scale(0.97);
  }
  75% {
    transform: translate(20px, 40px) scale(1.06);
  }
}
.toast-slide-in {
  animation: toast-in 0.3s ease-out forwards;
}

.toast-fade-out {
  animation: toast-out 0.4s ease-in forwards;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes toast-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}`],
})
export class PageMainComponent implements OnInit {
    // Search
    public searchCategory: string = 'researcher';
    public searchText: string = '';
    public activeCategory: string = 'researcher';

    public counts: any = {
        researcher: 0,
        organization: 0,
        publication: 0
    };

    public categories: any[] = [
        { key: 'researcher', label: '연구자', icon: 'fa-user-graduate', unit: '명' },
        { key: 'organization', label: '기관', icon: 'fa-building', unit: '개' },
        { key: 'publication', label: '성과물', icon: 'fa-file-alt', unit: '건' }
    ];

    // Auth
    public isLoggedIn: boolean = false;
    public currentUser: any = null;
    public showLoginModal: boolean = false;
    public loginEmail: string = '';
    public loginPassword: string = '';
    public loginError: string = '';
    public loginLoading: boolean = false;
    public showLogoutModal: boolean = false;

    // Toast
    public showToast: boolean = false;
    public toastMessage: string = '';
    public toastFading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCounts();
        this.updateAuthState();
        await this.service.render();
    }

    // --- Auth State ---
    public updateAuthState() {
        this.isLoggedIn = this.service.auth.status || false;
        if (this.isLoggedIn) {
            this.currentUser = this.service.auth.session;
        }
    }

    // --- Counts ---
    public async loadCounts() {
        let res = await wiz.call("count");
        if (res.code === 200) {
            this.counts.researcher = res.data.researcher || 0;
            this.counts.organization = res.data.organization || 0;
            this.counts.publication = res.data.publication || 0;
        }
    }

    public async selectCategory(key: string) {
        this.activeCategory = key;
        await this.service.render();
    }

    public getActiveUnit(): string {
        const cat = this.categories.find(c => c.key === this.activeCategory);
        return cat ? cat.unit : '';
    }

    public doSearch() {
        if (!this.searchText.trim()) return;
        location.href = `/search?q=${encodeURIComponent(this.searchText.trim())}&category=${this.searchCategory}`;
    }

    // --- Login Modal ---
    public async openLoginModal() {
        this.showLoginModal = true;
        this.loginEmail = '';
        this.loginPassword = '';
        this.loginError = '';
        await this.service.render();
    }

    public async closeLoginModal() {
        this.showLoginModal = false;
        this.loginError = '';
        await this.service.render();
    }

    public async doLogin() {
        if (!this.loginEmail.trim() || !this.loginPassword.trim()) {
            this.loginError = '이메일과 비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }
        this.loginLoading = true;
        this.loginError = '';
        await this.service.render();

        let res = await wiz.call("login", {
            email: this.loginEmail.trim(),
            password: this.loginPassword.trim()
        });

        this.loginLoading = false;

        if (res.code === 200) {
            this.showLoginModal = false;
            this.isLoggedIn = true;
            this.currentUser = res.data.user;
            this.showToastMessage('로그인이 완료되었습니다.');
        } else {
            this.loginError = res.data?.message || '로그인에 실패했습니다.';
        }
        await this.service.render();
    }

    // --- Logout Modal ---
    public async openLogoutModal() {
        this.showLogoutModal = true;
        await this.service.render();
    }

    public async closeLogoutModal() {
        this.showLogoutModal = false;
        await this.service.render();
    }

    public async confirmLogout() {
        let res = await wiz.call("logout");
        if (res.code === 200) {
            this.isLoggedIn = false;
            this.currentUser = null;
            this.showLogoutModal = false;
            await this.service.render();
        }
    }

    // --- Toast ---
    public async showToastMessage(message: string) {
        this.toastMessage = message;
        this.showToast = true;
        this.toastFading = false;
        await this.service.render();

        setTimeout(async () => {
            this.toastFading = true;
            await this.service.render();
            setTimeout(async () => {
                this.showToast = false;
                this.toastFading = false;
                await this.service.render();
            }, 400);
        }, 2600);
    }
}

export default PageMainComponent;